<div *ngIf="!value && value !== 0" class="crm-field-info-view">
  <mat-icon #crmFieldTooltip="matTooltip"
            [matTooltip]="fieldName + ' field is missing. Please update it in the CRM.'"
            matTooltipPosition="below">
    error_outline
  </mat-icon>
</div>
